import React from 'react';
import ConsentIntro from './ConsentIntro';
import UnderstandStatementQuestion from './UnderstandStatementQuestion';
import VoiceTranscribingServiceQuestion from './VoiceTranscribingServiceQuestion';
import OtherReasonTextarea from './OtherReasonTextarea';
import { AboutMeTypes } from '../../StepThreeTypes';
import getVoiceToTextBlockedMessages from './utils';

interface VoiceTranscribingProps {
  aboutMe: AboutMeTypes;
  setAboutMe: React.Dispatch<React.SetStateAction<AboutMeTypes>>;
}

const VoiceTranscribing: React.FC<VoiceTranscribingProps> = ({
  aboutMe,
  setAboutMe,
}) => {
  const { voiceTranscribingConsent } = aboutMe;
  return (
    <div>
      <ConsentIntro />
      <UnderstandStatementQuestion
        value={voiceTranscribingConsent?.understandsStatement}
        onChange={value =>
          setAboutMe(prev => ({
            ...prev,
            voiceTranscribingConsent: {
              ...prev.voiceTranscribingConsent,
              understandsStatement: value,
            },
          }))
        }
      />

      <VoiceTranscribingServiceQuestion
        value={voiceTranscribingConsent?.happyForTranscribingService}
        onChange={value =>
          setAboutMe(prev => ({
            ...prev,
            voiceTranscribingConsent: {
              ...prev.voiceTranscribingConsent,
              happyForTranscribingService: value,
            },
          }))
        }
      />
      <OtherReasonTextarea
        value={voiceTranscribingConsent?.otherReason}
        onChange={value =>
          setAboutMe(prev => ({
            ...prev,
            voiceTranscribingConsent: {
              ...prev.voiceTranscribingConsent,
              otherReason: value,
            },
          }))
        }
      />
    </div>
  );
};

export default VoiceTranscribing;
